import ImageSelector from '@di-shared/features/common/ImageSelector';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import React from 'react';

export default function IntroduceBottomSheetKr() {
  const {t} = useInferableTranslation();

  return (
    <div className="bottom_sheet bottom_sheet_intro_guide">
      <div className="bottom_sheet_header">
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
          onClick={() => window.bottomSheetClose(false)}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <strong className="intro_guide_title">
            <span className="title_text">{t('T20212')}</span>
            <span
              className="ic logo_driving_insight"
              role="img"
              aria-label={t('T10162')}
            />
          </strong>
          <div className="intro_guide_imgbox">
            <ImageSelector
              className="intro_guide_img"
              alt="intro_guide_img"
              kiaLightSrc={() => import('@di-shared/assets/img/home/intro_guide_light.png')}
              kiaDarkSrc={() => import('@di-shared/assets/img/home/intro_guide.png')}
              hyundaiLightSrc={() => import('@di-shared/assets/img/home/hyundai/intro_guide_light.png')}
              hyundaiDarkSrc={() => import('@di-shared/assets/img/home/hyundai/intro_guide.png')}
              genesisLightSrc={() => import('@di-shared/assets/img/home/genesis/intro_guide_light.png')}
              genesisDarkSrc={() => import('@di-shared/assets/img/home/genesis/intro_guide.png')}
            />
          </div>
        </div>

        <div className="bottom_sheet_footer">
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => window.bottomSheetClose(true)}
          >
            {t('T20213')}
          </button>
        </div>
      </div>
    </div>
  );
}
